import React, { Component } from "react";
import { Card, Button, Table, Select, Input, message, Tag, Modal } from "antd";

import { connect } from "react-redux";
import { req_page_historyapplycase, req_edit_applycase } from "../../api";

import { padLeft } from "../../utils/dataUtil";
import { formateDate } from "../../utils/dateUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";

import MyApplyCaseWorkflow from "./my-apply-case-workflow";

class MyHistoryReviewCase extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    applycases: [],
    applycase: {}, // selected
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "",
    loading: false,
    isShowWorkflowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_applycase(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_applycase = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode } = this.props.user;
    this.setState({ loading: true, items: [] });
    const result = await req_page_historyapplycase(
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const applycases = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ applycases, pagination });
      //console.log(this.state);
    } else {
      const applycases = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ applycases, pagination });
    }
  };

  api_edit_applycase = async (applycase) => {
    const token = this.props.user.token;
    //this.setState({ loading: true })
    const result = await req_edit_applycase(applycase, token);
    //this.setState({ loading: false })
    if (result.status === "success") {
      message.success(result.message);
      this.api_page_applycase(this.current);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  style_switch_color(param) {
    switch (param) {
      case "SAVE_CASE":
        return "DarkRed";
      case "PROCESS_CASE":
        return "DarkRed";
      case "RETURN_APPLY_CASE":
        return "DarkMagenta";
      case "RETURN_END_CASE":
        return "DarkGray";
      case "CLOSED_CASE":
        return "DarkGreen";
      default:
        return "Black";
    }
  }
  style_switch_decoration(param) {
    switch (param) {
      case "SAVE_CASE":
      case "RETURN_APPLY_CASE":
        return "none";
      case "RETURN_END_CASE":
      case "CLOSED_CASE":
        return "line-through";
      default:
        return "none";
    }
  }
  style_switch_color_tag(param) {
    switch (param) {
      case "SAVE_CASE":
        return "green";
      case "RETURN_APPLY_CASE":
        return "red";
      case "PENDING_CASE":
        return "purple";
      case "PROCESS_CASE":
        return "DarkRed";
      case "REPORT_CASE":
        return "DarkGreen";
      case "RETURN_END_CASE":
      case "CLOSED_CASE":
        return "DarkGray";
      default:
        return "default";
    }
  }

  init_columns = () => {
    this.columns = [
      {
        title: "案件編號",
        dataIndex: "CaseNid",
        fixed: "left",
        width: 65,
        render: (CaseNid) => "N" + padLeft(CaseNid, 7),
      },
      {
        title: "案件日期",
        dataIndex: "RecordCreateDateTime",
        width: 65,
        render: (RecordCreateDateTime) => formateDate(RecordCreateDateTime),
        responsive: ["md"],
      },
      {
        title: "案件說明",
        dataIndex: "CaseContent",
        width: 100,
        responsive: ["md"],
      },
      {
        title: "保管單位",
        dataIndex: "AdministrationDept",
        width: 60,
        responsive: ["md"],
      },
      {
        title: "資訊教室",
        dataIndex: "RoomCode",
        width: 60,
        responsive: ["md"],
      },
      {
        title: "電腦編號",
        dataIndex: "ComputerCode",
        width: 60,
      },
      {
        title: "狀態",
        filters: [
          { text: "尚未送審", value: "SAVE_CASE" },
          { text: "送案待審", value: "PENDING_CASE" },
          { text: "收案處理", value: "PROCESS_CASE" },
          { text: "退回修正", value: "RETURN_APPLY_CASE" },
          { text: "退回重分", value: "RETURN_PROCESS_CASE" },
          { text: "註銷申請", value: "RETURN_END_CASE" },
          { text: "案件完成", value: "CLOSED_CASE" },
        ],
        filterMultiple: false,
        width: 45,
        render: (applycase) => {
          const { CaseNid, CaseStatus, CaseStatusName } = applycase;
          let color = this.style_switch_color_tag(CaseStatus);
          return (
            // <>
            //     <span style={{ color: this.style_switch_color(CaseStatus), textDecoration: this.style_switch_decoration(CaseStatus) }}>{CaseStatusName}</span>
            // </>
            <>
              <Tag color={color} key={CaseNid}>
                {CaseStatusName}
              </Tag>
            </>
          );
        },
      },
      {
        title: "操作",
        width: 55,
        fixed: "right",
        render: (applycase) => {
          const { CaseNid } = applycase;
          return (
            <span>
              <Button
                type="dashed"
                size="small"
                style={{ color: "DarkGreen" }}
                onClick={() =>
                  this.props.history.push("/fixcomputer/applycase/details", {
                    applycase,
                  })
                }
              >
                <i className="fa fa-file"></i>
                <span style={{ marginLeft: "2px" }}>明細</span>
              </Button>
              <Button
                type="dashed"
                size="small"
                style={{ color: "DarkBlack" }}
                onClick={() => this.handle_show_ui_workflow_applycase(CaseNid)}
              >
                <i className="fa fa-ellipsis-v"></i>
                <span style={{ marginLeft: "9px" }}>紀錄</span>
              </Button>
            </span>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_applycase(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_applycase(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_applycase(pagination.current);
        });
      }
    } else {
      this.api_page_applycase(pagination.current);
    }
  };

  handle_edit_status = (uid, CaseNid, newStatus, condition) => {
    const applycase = {
      Uid: uid,
      CaseNid: CaseNid,
      caseStatus: newStatus,
      condition: condition,
    };
    this.api_edit_applycase(applycase);
  };

  handle_show_ui_workflow_applycase = (CaseNid) => {
    const applycase = {
      CaseNid: CaseNid,
    };
    //console.log(applycase)
    this.setState({ isShowWorkflowModal: true, applycase });
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      applycase,
      applycases,
      pagination,
      searchField,
      searchValue,
      isShowWorkflowModal,
    } = this.state;
    const id = applycase.CaseNid ? applycase.CaseNid : 0;
    const title = (
      <span>
        <Select
          value={searchField}
          style={{ width: 100 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="RoomCode">教室編號</Select.Option>
          <Select.Option value="ComputerCode">電腦編號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_applycase(1)}>
          <i class="fa fa-search"></i>
          <span style={{ marginLeft: "2px" }}>查詢</span>
        </Button>
      </span>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={applycases}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />

        <Modal
          destroyOnClose={true}
          title="作業紀錄"
          visible={isShowWorkflowModal}
          footer={[
            <Button
              key="back"
              onClick={() => {
                this.setState({ isShowWorkflowModal: false });
              }}
            >
              關閉
            </Button>,
          ]}
        >
          <MyApplyCaseWorkflow CaseNid={id} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(MyHistoryReviewCase);
